const AWS_REGION = process.env.REACT_APP_AWS_REGION;
const COGNITO_USERPOOL = process.env.REACT_APP_COGNITO_USERPOOL;
const COGNITO_USERPOOL_WEBCLIENT = process.env.REACT_APP_COGNITO_USERPOOL_WEBCLIENT;

export { AWS_REGION, COGNITO_USERPOOL, COGNITO_USERPOOL_WEBCLIENT};